import { Box } from "@material-ui/core";
import { useHistory } from "react-router";
import BreadcrumbNav from "../../../../components/BreadcrumbNav/BreadcrumbNav";
import ProductTable from "./ProductTable";

const SupplierProducts = () => {
  const history = useHistory();

  return (
    <section className="layout-dashboard-container">
      <div className="header-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div>
            <h4 className="header-title">Gestión de Productos para Tienda</h4>
            <BreadcrumbNav
              firstText="Proveedor"
              secondText="Productos"
              secondLink="/proveedor/producto/lista"
              thirdText={"Lista"}
            />
          </div>
          
        </Box>
      </div>

      <ProductTable />
    </section>
  );
};
export default SupplierProducts;
